<template>
  <div
    v-show="show"
    class="video-end"
    :class="{ 'is-full-screen': isFullScreen }"
  >
    <img class="video-end-background" :src="background" />

    <div v-if="timer && time > 0" class="video-end-auto-play">{{ time }}s后自动播放下一节</div>

    <div class="video-end-content">
      <div class="video-end-control" :style="{ 'justify-content' : usefulTipShow ? 'flex-start' : 'center' }">
        <div v-if="usefulTipShow" class="video-end-useful">
          <span class="video-end-useful-title">这个技巧对你有帮助吗？</span>
          <span class="video-end-useful-box">
            <span
              class="video-end-useful-button"
              :class="{ 'is-selected': useful === item.value }"
              v-for="item in usefulBtns"
              :key="item.value"
              @click="handleSelUseful(item.value)"
            >
              <icon :type="item.icon"></icon><span>{{ item.name }}</span>
            </span>
          </span>
        </div>

        <div class="video-end-control-btn" @click="handleReplay">
          <icon type="iconic_replay"></icon>
          <span>重播</span>
        </div>

        <div
          class="video-end-control-btn"
          @click="handleNext"
          v-if="nextCourseUrl && isSubject"
        >
          <icon type="iconic_next"></icon>
          <span>下一个</span>
        </div>
      </div>

      <template v-if="recommendData.length > 0">
        <div class="video-end-course-label">推荐课程</div>

        <div class="video-end-course-list">
          <lr-link
            class="video-end-course-item"
            v-for="(item, index) in recommendData"
            :key="index"
            :to="videoEndURLHandler(item)"
            target="_blank"
            @click="reportClick({ click: `end_${index + 1}`, listid: item.id })"
          >
            <img
              class="video-end-course-item-cover"
              :src="getCourseBackgroundUrl(item)"
            />
            <div
              class="video-end-course-item-title ellipsis-2"
              :class="{ jpk: isJpk(item) }"
              v-html="getCourseBackgroundTitle(item)"
            ></div>
            <div class="video-end-course-item-play">
              <icon type="iconic_play_min"></icon>立即学习
            </div>
            <div class="video-end-course-item-bottom" v-show="isJpk(item)">
              <icon type="iconic_jingpinke"></icon>精品课会员专享
            </div>
          </lr-link>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { TOP_CATE_MAP } from '@/common/constant';
import { VIDEO_AUTO_PALY_KEY } from '@/common/constant/storage-key';
import { sessionStore } from '@/common/utils/storage';

import {
  getCourseBackgroundTitle,
  getCourseBackgroundUrl,
  getCourseBackgroundType,
  jpkUrlHandler,
} from '@/common/utils';

const usefulBtns = [
  {
    name: '有帮助',
    icon: 'iconic_useful',
    value: 1,
  },
  {
    name: '无帮助',
    icon: 'iconic_useless',
    value: 0,
  },
];

export default {
  data() {
    return {
      show: false,
      usefulBtns,
      hash: '',

      usefulLoading: false,
      useful: null,
      recommendData: [],

      time: 0,
      timer: null,

      // 首次初始化默认当前获得焦点
      isWindowFocus: true
    };
  },

  props: {
    background: String,
    id: [Number, String],
    player: {
      type: Object,
      default: () => ({}),
    },
    cate: String,
    nextCourseUrl: String,
    isSubject: Boolean,
    isCanPlayNextCourse: Boolean,
    reportClick: Function,
    reportShow: Function,
    usefulTipShow: Boolean,
    isFullScreen: Boolean,
  },

  watch: {
    show(val) {
      // 上报展示
      if (val) {
        this.reportShow({ show: 'overrecommend' });

        // 自动播放下一个视频条件：
        // 1.系列课程 & 存在一个课程url && 非最后一节课
        // 2.用户当前焦点在当前窗口
        if (this.isCanPlayNextCourse && this.isWindowFocus && !document.hidden) {
          this.reportShow({ show: 'autoplay' });
          this.time = 3;
          if (this.timer) clearInterval(this.timer);
          this.timer = setInterval(() => {
            this.time--;
            if (this.time <= 0) {
              // 自动播放下一节
              this.handleAutoPlay();
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      } else {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },

  methods: {
    async handleSelUseful(val) {
      const { id, usefulLoading } = this;

      this.$emit('useful-click', val);
      // 已选择不能调整
      if (this.useful !== null || usefulLoading) return;
      this.usefulLoading = true;
      this.reportClick({ click: val ? 'Bhelp' : 'Bnohelp' });

      if (!this.hash) {
        this.hash = await this.$service.learning.getFbToken().catch(() => '');
      }
      this.$service.learning
        .submitComment({
          id,
          isHelp: val,
          fromChannel: 1,
          token: this.hash,
        })
        .then((res) => {
          if (res.code === 200) {
            this.useful = val;
          } else {
            this.$toast('提交失败，请重试');
          }
        })
        .finally(() => {
          this.usefulLoading = false;
        });
    },

    // 点击重播
    handleReplay() {
      this.reportClick({ click: 'replay' });
      this.player.play();
    },

    // 点击下一个
    handleNext() {
      this.reportClick({ click: 'next' });
      location.href = this.nextCourseUrl;
    },

    /**
     * 处理自动播放视频(同一时间仅有一个自动播放页面，采用覆盖方式进行存储)
     * ## 自动播放校验逻辑：
     * 1.session存储pathname/rate/muted/time
     * 2.跳转新页面携带当前time用于做时间标记
     */
    handleAutoPlay() {
      let params = this.nextCourseUrl.indexOf('?') > -1 ? '&' : '?';
      try {
        let now = Date.now();
        sessionStore.set(VIDEO_AUTO_PALY_KEY, {
          url: this.nextCourseUrl,
          rate: this.player.playbackRate(),
          volume: this.player.volume(),
          muted: this.player.muted(),
          time: now
        });
        params += `t=${now}`;
      } catch (e) {
        params += `play=${true}`;
      }

      location.href = this.nextCourseUrl + params;
    },

    async getVideoEndData() {
      const res = await this.$service.learning.getCourseEndData(
        TOP_CATE_MAP[this.cate] || this.cate
      );

      if (res && res.data) {
        const data = res.data.subjects.slice(0, 6);
        this.recommendData = data;
      }
    },

    isJpk(data) {
      const type = getCourseBackgroundType(data);

      return type.indexOf('jpk_') !== -1;
    },

    getCourseBackgroundUrl,

    getCourseBackgroundTitle,

    videoEndURLHandler(item) {
      if (this.isJpk(item)) {
        return jpkUrlHandler(item.redirectUrl || item.url, 'wps_xy_end');
      } else {
        return item.redirectUrl || item.url;
      }
    },
  },

  mounted() {
    this.getVideoEndData();

    // 监听窗口 - 判断当前窗口是否获得焦点
    window.addEventListener('focus', this.handleWindowFocus = () => {
      this.isWindowFocus = true;
    });
    window.addEventListener('blur', this.handleWindowBlur = () => {
      this.isWindowFocus = false;
    });
  },

  beforeDestroy() {
    clearInterval(this.timer);

    window.removeEventListener('focus', this.handleWindowFocus);
    window.removeEventListener('blur', this.handleWindowBlur);
  }
};
</script>

<style lang="scss" scoped>
.video-end {
  font-family: '微软雅黑';

  &-background {
    display: block;
    width: 100%;
    height: 100%;
  }

  &.is-full-screen {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      z-index: 1;
    }

    .video-end-auto-play {
      top: 24px;
      right: 24px;
      font-size: 14px;
    }

    .video-end-content {
      left: 50%;
      top: 50%;
      width: 832px;
      max-height: 510px;
      padding: 0;
      background: none;
      transform: translate(-50%, -50%);
      z-index: 2;
    }

    .video-end-useful {
      margin-right: 472px;
    }

    .video-end-course {
      &-label {
        margin: 60px 0px 14px;
      }

      &-item {
        width: 256px;
        max-height: 144px;
        margin-right: 32px;

        &:nth-of-type(3n) {
          margin-right: 0;
        }

        &-title {
          width: 160px;
          line-height: 32px;
          font-size: 24px;
        }

        &-bottom {
          height: 24px;
        }
      }
    }
  }

  &-content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 60px 145px 0;
    background: rgba(0, 0, 0, 0.7);
  }

  &-auto-play {
    position: absolute;
    top: 16px;
    right: 16px;

    line-height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: #FFFFFF;
    z-index: 2;
  }

  &-useful {
    display: flex;
    flex-direction: column;
    line-height: 20px;
    color: #ffffff;
    margin-right: 152px;

    &-title {
      line-height: 22px;
      margin-bottom: 14px;

      font-size: 14px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.95);
    }

    &-box {
      display: flex;
    }

    &-button {
      display: flex;
      align-items: center;
      justify-content: center;

      width: 120px;
      height: 40px;
      background-color: rgba(255, 255, 255, 0.2);
      border-radius: 20px;

      color: #FFFFFF;
      user-select: none;
      cursor: pointer;

      &:hover {
        background-color: rgba(255, 255, 255, 0.4);
      }

      &:active {
        background-color: rgba(255, 255, 255, 0.3);
      }

      &.is-selected {
        background-color: #417FF9;
      }

      .icon {
        font-size: 25px;
        margin-right: 4px;
        margin-bottom: 2px;
      }

      span {
        line-height: 22px;
      }

      & + .video-end-useful-button {
        margin-left: 16px;
      }
    }
  }

  &-control {
    display: flex;

    &-btn {
      box-sizing: border-box;
      display: inline-flex;
      flex-direction: column;
      align-items: center;

      padding-top: 32px;
      font-size: 12px;
      color: #fff;
      cursor: pointer;

      .icon {
        font-size: 24px;
        margin-right: 4px;
        margin-bottom: 2px;
      }

      &.active .icon {
        color: #417ff9;
      }

      > span {
        line-height: 22px;
      }

      & + .video-end-control-btn {
        margin-left: 40px;
      }
    }
  }

  &-course-label {
    line-height: 24px;
    margin: 24px 0px 14px;

    font-size: 14px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.95);
  }

  &-course-list {
    display: flex;
    flex-wrap: wrap;
  }
  &-course-item {
    display: block;
    position: relative;
    width: 160px;
    max-height: 90px;
    margin-right: 15px;
    margin-bottom: 15px;
    cursor: pointer;
    overflow: hidden;

    &:nth-of-type(3n) {
      margin-right: 0;
    }

    &-play {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: none;
      width: 104px;
      height: 30px;
      background: rgba(0, 0, 0, 0.7);
      border-radius: 18px;
      color: #fff;

      .icon {
        font-size: 16px;
        margin-right: 4px;
      }
    }

    &-title {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 100px;
      font-size: 14px;
      font-weight: 600;
      color: #ffffff;
      line-height: 20px;
      text-align: center;
    }

    &-cover {
      display: block;
      width: 100%;
    }

    &-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 20px;
      @include flex-center();
      background: rgba(0, 0, 0, 0.4);
      color: #fff;
      font-size: 12px;
      .icon {
        font-size: 14px;
        margin-right: 4px;
      }
    }

    &:hover {
      .video-end-course-item-play {
        @include flex-center();
      }
    }
  }
}
</style>
